import { render, staticRenderFns } from "./iDSBottomBtn.vue?vue&type=template&id=40dbd9cd"
import script from "./iDSBottomBtn.vue?vue&type=script&lang=js"
export * from "./iDSBottomBtn.vue?vue&type=script&lang=js"
import style0 from "./iDSBottomBtn.vue?vue&type=style&index=0&id=40dbd9cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports